(ns capra.transport
  "Client-side transport protocol.")

(defprotocol ICapraTransport
  (send-pipeline! [this pipeline-msg]
    "Send an :rpc/call message to the server.
     Returns Promise<{:results {op-id -> value} :caps [advertisements]}>.")

  (send-release! [this cap-ids fn-ids]
    "Send an :rpc/release message to the server.")

  (on-push! [this handler-fn]
    "Register handler for :rpc/push messages (server callback invocations).
     handler-fn receives {:fn-id string :args vector}.")

  (on-welcome! [this handler-fn]
    "Register handler for :rpc/welcome message on connect.
     handler-fn receives the welcome message.")

  (on-reconnect! [this handler-fn]
    "Register handler called after transport reconnects.")

  (close! [this]
    "Tear down transport."))
